import React, { useState } from "react";
import { Card, Container, Row, Col, Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";


function About() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [gallery, setGallery] = useState(false);
    const [activeImage, setActiveImage] = useState(false);
    return (
        <>
            <div className="product">
            <div class="container-fluid bg-dark p-0">
                <div class="row gx-0 d-none d-lg-flex">
                    <div class="col-lg-7 px-5 text-start">
                        <div class="h-100 d-inline-flex align-items-center me-4">
                            <small class="fa fa-map-marker-alt text-primary me-2"></small>
                            <small>Opposite Safron Landmark, Beed Bypass, Aurangabad-431010</small>
                        </div>
                        <div class="h-100 d-inline-flex align-items-center">
                            <small class="far fa-clock text-primary me-2"></small>
                            <small>Mon - Fri : 09.00 AM - 09.00 PM</small>
                        </div>
                    </div>
                    <div class="col-lg-5 px-5 text-end">
                        <div class="h-100 d-inline-flex align-items-center me-4">
                            <small class="fa fa-phone-alt text-primary me-2"></small>
                            <small>7798121291</small>
                        </div>
                        <div class="h-100 d-inline-flex align-items-center mx-n2">
                            <a class="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href=""><i class="fab fa-facebook-f"></i></a>
                            <a class="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href=""><i class="fab fa-twitter"></i></a>
                            <a class="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href=""><i class="fab fa-linkedin-in"></i></a>
                            <a class="btn btn-square btn-link rounded-0" href=""><i class="fab fa-instagram"></i></a>
                        </div>
                    </div>
                </div>
            </div>
                {/* <!-- Topbar End --> */}


                {/* <!-- Navbar Start --> */}
                <nav class="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0">
                <a href="index.html" class="navbar-brand d-flex align-items-center border-end px-4 px-lg-5">
                    <img src="img/logo.jpeg" width="100" />
                </a>
                <button type="button" class="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarCollapse">
                    <div class="navbar-nav ms-auto p-4 p-lg-0">
                        <Link to="/"><a href="/" class="nav-item nav-link active">Home</a></Link>
                        <Link to="/about"> <a href="/about" class="nav-item nav-link">About</a></Link>
                        <div class="nav-item dropdown">
                            <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">Service</a>
                            <div class="dropdown-menu bg-light m-0">
                            <Link to="/enginerringServices"> <a href="/enginerringServices" class="dropdown-item">Engineering and Consultancy Service</a></Link>
                            <Link to="/fireHydrant"><a href="/fireHydrant" class="dropdown-item">Fire Hydrant System</a></Link>
                            <Link to="/firesprinkler"><a href="/firesprinkler" class="dropdown-item">Fire Sprinkler System</a></Link>
                            <Link to="/fireAlarm"><a href="/fireAlarm" class="dropdown-item">Fire Alarm and Detection System</a></Link>
                            <Link to="/publicAddress"><a href="/publicAddress" class="dropdown-item">Public Address System</a></Link>
                            <Link to="/accessControl"><a href="/accessControl" class="dropdown-item">Access Control System</a></Link>
                            <Link to="/transformerProtection"><a href="/transformerProtection" class="dropdown-item">Transformer Protection System</a></Link>
                            <Link to="/integratedSecurity"><a href="/integratedSecurity" class="dropdown-item">Integrated Security System</a></Link>
                            </div>
                        </div>
                        <Link to="/contact"> <a href="/contact" class="nav-item nav-link">Contact</a></Link> 
                    </div>
                </div>
            </nav>
                {/* <!-- Navbar End --> */}

                {/* <!-- Page Header Start --> */}
                <div class="container-fluid page-header py-5 mb-5">
                    <div class="container py-5">
                        <h1 class="display-3 text-white mb-3 animated slideInDown">About Us</h1>
                        <nav aria-label="breadcrumb animated slideInDown">

                        </nav>
                    </div>
                </div>
                {/* <!-- Page Header End --> */}

                {/* <!-- Start: Filterable Gallery with Lightbox --> */}
                <section id="filtr-gallery" >
                    <div class="container">
                        <hr />

                        <h2 class="title text-center head" >ENGINEERING SERVICES AND CONSULTANCY</h2>


                        <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
                            <p class="description" style={{color:'black'}}>The prerequisite of every Fire Protection Project we undertake is the sound engineering design. To create
                                an effective Fire Protection Systems for a given project our engineers determine the most optimum
                                approach which gives a technically sound and commercially viable solution.
                                We offers total design engineering services to Industries, Commercial, Residential and Public utilities
                                buildings</p>
                        </div>
                        <div className="row mt-5">
                            <div className="col-md-6">
                                <ul style={{color:'black'}}>
                                    <li >Basic Engineering</li>
                                    <li>Design Basis Report of Fire Protection Systems</li>
                                    <li>Hydraulic Calculation of Hydrant and Sprinkler System</li>
                                    <li>Process & Instrumentation Diagrams (P&IDs)</li>
                                    <li>Piping and Equipment Specifications</li>
                                    <li>Fire protection accessories specifications</li>
                                    <li>Bill of Quantity (BOQ)</li>
                                    <li>Loop Analysis</li>
                                    <li>Seismic bracing & Orifice plate calculations</li>
                                    <li>Control Logic Philosophy</li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <ul style={{color:'black'}}>
                                    <li>Layouts: Fire Hydrant System, Sprinkler system, Fire Detection and
                                        Alarm System & Public Address System</li>
                                    <li>Budget Cost Estimation</li>
                                    <li>Tender documents</li>
                                    <li>Technical Support for Statutory Approvals</li>
                                    <li>Procurement Assistance</li>
                                    <li>Vendor Monitoring and Expediting</li>
                                    <li>Industrial Safety and Fire Audit</li>
                                    <li>Certification for obtaining Final Fire NOC / Renewal – Form A and
                                        Form B forma</li>
                                </ul>
                            </div>
                        </div>
                        <hr />

                        <h2 class="title text-center head" >OUR SUPPORT SERVICES</h2>


                        <div class="icon-box" data-aos="fade-up" data-aos-delay="100" style={{color:'black'}}>
                            <p class="description">1) AMC For Fire Fighting Products And Systems.</p>
                            <p class="description">2) AMC For All Integrated Building Management CCTV, Public Address System, Rodent Repellent
                                System, Access Control System.</p>
                            <p class="description">3) Fire Risk Assessments And Audits, Safety Audits as per IS 14489, NBC 16 Assessments.</p>
                            <p class="description">4) Fire Risk Assessments And Audits, Safety Audits as per IS 14489, NBC 16 Assessments.</p>
                            <p class="description">5) Deploy Trained, Qualified And Committed Fire And Safety Staff (Outsourcing Solution).
                                .</p>
                        </div>
                        <div className="row mt-5 mb-5">
                            <div className="col-md-4">
                                <img src="./img/1.png" style={{ width: '900px', height: '300px' }} class="img-fluid serv" alt="" />
                            </div>

                            <div className="col-md-4">
                                <img src="./img/2.png" style={{ width: '900px', height: '300px' }} class="img-fluid serv" alt="" />

                            </div>
                            <div className="col-md-4">
                                <img src="./img/3.png" style={{ width: '900px', height: '300px' }} class="img-fluid serv" alt="" />

                            </div>
                        </div>
                        <hr />

                        <div class="image mt-5">
                            <img src="./img/client.png" style={{ width: '1600px', height: '700px' }} class="img-fluid" alt="" />
                        </div>

                        {/* <!-- End: images --> */}
                    </div>
                </section>
                {/* <!-- ======= Footer ======= --> */}
                <div class="container-fluid bg-dark text-body footer mt-5 pt-5 wow fadeIn" data-wow-delay="0.1s">
                <div class="container py-5">
                    <div class="row g-5">
                        <div class="col-lg-3 col-md-6">
                            <h5 class="text-white mb-4">Address</h5>
                            <p class="mb-2"><i class="fa fa-map-marker-alt me-3"></i>Office no-611, Vastu Elite Square,, Opposite Safron Landmark, Beed Bypass, Aurangabad-431010
                                <br/>Email-services@ssfireengineers.com
                                <br/>Phone:- 77981 21291</p>
                            <div class="d-flex pt-2">
                                <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-twitter"></i></a>
                                <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-facebook-f"></i></a>
                                <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-youtube"></i></a>
                                <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <h5 class="text-white mb-4">Quick Links</h5>
                            <a class="btn btn-link" href="/">Home</a>
                            <a class="btn btn-link" href="/about">About Us</a>
                            <a class="btn btn-link" href="/contact">Contact Us</a>
                        </div>

                        <div class="col-lg-3 col-md-6">
                            <h5 class="text-white mb-4">Newsletter</h5>
                            <div class="position-relative mx-auto" style={{ maxwidth: '400px' }}>
                                <input class="form-control border-0 w-100 py-3 ps-4 pe-5" type="text" placeholder="Your email" />
                                <button type="button" class="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2">SignUp</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="copyright">
                        <div class="row">
                            <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                                &copy; <a href="#">SS FIRE ENGINEERS</a>, All Right Reserved.
                            </div>
                            <div class="col-md-6 text-center text-md-end">
                                {/* This template is free as long as you keep the footer author’s credit link/attribution link/backlink. If you'd like to use the template without the footer author’s credit link/attribution link/backlink, you can purchase the Credit Removal License from "https://htmlcodex.com/credit-removal". Thank you for your support.  */}
                                Designed By <a href="#">BFI</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>

        </>
    );
}

export default About;

